import styled from "@emotion/styled";
import {
  SubmitButton,
  SubmitButtonProps,
  Divider,
} from "@avenue-8/sidekick-ui";

export const SubscriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 1rem;
  color: ${(p) => p.theme.text.colors.primary};
  width: 100%;
  max-width: 600px;

  ${(p) => p.theme.media.mobileDown} {
    padding: 1.5rem;
    max-width: 100%;
  }
`;

export const SubscriptionSubmitButton = styled(SubmitButton)<SubmitButtonProps>`
  min-width: 160px;

  ${(p) => p.theme.media.mobileDown} {
    width: 100%;
  }
`;

export const HorizontalDivider = styled(Divider)`
  margin-top: 2rem;
  margin-bottom: 2rem;
`;
